'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import LobbyPageSkeleton from '@/components/skeletons/LobbyPageSkeleton';
import { useNavigation } from '@/hooks/navigation';
import { useGetCommonStore, useModalsStore } from '@/store';

export default function SignIn() {
  const { navigate } = useNavigation();
  const searchParams = useSearchParams().toString();
  const useCommonStore = useGetCommonStore();

  const open = useModalsStore.use.open();
  const pendingUser = useCommonStore.use.pendingUser();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  useEffect(() => {
    if (pendingUser) return;
    if (isAuthenticated)
      return navigate(searchParams ? `/?${searchParams}` : '/');

    navigate(
      `/${searchParams ? `?${searchParams}&modal=login` : '?modal=login'}`,
      true
    );
  }, [pendingUser, open, navigate, searchParams, isAuthenticated]);

  return <LobbyPageSkeleton withTitle />;
}
